import { render, staticRenderFns } from "./proofService.vue?vue&type=template&id=805c24e2&scoped=true&"
import script from "./proofService.vue?vue&type=script&lang=js&"
export * from "./proofService.vue?vue&type=script&lang=js&"
import style0 from "./proofService.vue?vue&type=style&index=0&id=805c24e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805c24e2",
  null
  
)

export default component.exports